import { state, createMachine, transition, invoke, reduce } from "robot3";
import { emptyMeetingType } from "../common/types";
import { wpFetchRestApi, isWpSuccess } from "../util";
import { setSelectedDay } from "./store";
import { useMachine } from "svelte-robot-factory";
import { get } from "svelte/store";
const clearSelectedDay = (ctx) => (Object.assign(Object.assign({}, ctx), { selectedDay: undefined }));
const clearError = (ctx) => (Object.assign(Object.assign({}, ctx), { error: undefined }));
const storeError = (ctx, ev) => (Object.assign(Object.assign({}, ctx), { error: ev.error }));
const storeSelectedDay = (ctx, ev) => (Object.assign(Object.assign({}, ctx), { selectedDay: ev.data.day }));
const storeNewDayWithSideEffects = (ctx, ev) => {
    setSelectedDay(ev.data);
    return ctx;
};
const storeInitialization = (ctx, ev) => (Object.assign(Object.assign({}, ctx), { types: ev.data.types, values: Object.assign(Object.assign({}, ctx.values), { type: ev.data.initialType, title: ev.data.initialType.default_title, description: ev.data.initialType.default_description }) }));
const storeDefaultTitleAndDescription = (ctx) => (Object.assign(Object.assign({}, ctx), { values: Object.assign(Object.assign({}, ctx.values), { title: ctx.values.type.default_title, description: ctx.values.type.default_description }) }));
const machine = createMachine({
    not_initialized: state(transition('init', 'idle', reduce(storeInitialization))),
    idle: state(transition('add', 'editing')),
    editing: state(transition('add', 'saving', reduce(storeSelectedDay)), transition('type_changed', 'editing', reduce(storeDefaultTitleAndDescription)), transition('cancel', 'idle')),
    saving: invoke(addMeeting, transition('done', 'idle', reduce(storeNewDayWithSideEffects), reduce(clearSelectedDay), reduce(clearError)), transition('error', 'editing', reduce(storeError))),
});
async function addMeeting(ctx) {
    if (ctx.selectedDay == undefined)
        throw new Error("Selected day is missing!");
    const endpoint = 'meeting';
    const calendarDay = ctx.selectedDay;
    const day = calendarDay.day;
    const time = ctx.values.time;
    const duration_in_minutes = ctx.values.duration_in_minutes;
    const type = ctx.values.type.type;
    const title = ctx.values.title;
    const description = ctx.values.description;
    const result = await wpFetchRestApi(endpoint, 'POST', { day, time, duration_in_minutes, type, title, description });
    if (isWpSuccess(result)) {
        return result.data;
    }
    throw new Error(result.message);
}
const initialContext = {
    types: [],
    values: {
        type: emptyMeetingType,
    },
};
export const service = useMachine(machine, initialContext);
export const createAddEvent = (selectedDay) => ({
    type: 'add',
    data: {
        day: selectedDay,
    }
});
export const initialize = (types, initialType) => {
    const ev = {
        type: 'init',
        data: {
            initialType,
            types
        },
    };
    const s = get(service);
    s.send(ev);
};
